
import { mapState } from "vuex";

import { PAGE_TYPE, PLP_QUERY } from "./-products.query";
import {
  seoMixin,
  pageMixin,
  itemListSchemaMixin,
  faqSchemaMixin,
} from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin, itemListSchemaMixin, faqSchemaMixin],

  async asyncData({ app, store, params: { handle }, route, error }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: PLP_QUERY,
      variables: { uid: handle, lazy: false },
    });

    if (data?.collection == null || (data?.slices ?? []).length == 0) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    const plpBanner = data.plp_banner_link;
    const bannerConfig = plpBanner?.display_banners
      ? {
          productTileBanners: [
            { image: plpBanner.image_1, image_link: plpBanner.image_1_link },
            { image: plpBanner.image_2, image_link: plpBanner.image_2_link },
          ].filter(({ image }) => image),
          heroBanner: {
            image: plpBanner.image,
            image_link: plpBanner.image_link,
          },
        }
      : null;

    return {
      title: data.title,
      uid: handle,
      pageType: PAGE_TYPE,
      slices: data.slices,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      context: { collection: data.collection, bannerConfig },
    };
  },

  computed: {
    ...mapState("app", ["isFilterPanelOpen"]),

    additionalScripts() {
      const itemList = this.itemListSchemaScript
        ? [this.itemListSchemaScript]
        : [];
      return [...itemList, ...this.faqSchemaScripts].filter(Boolean);
    },

    // Preload hero banner image (seoMixin will place it first for maximum priority)
    additionalLinks() {
      const heroBanner = this.context?.bannerConfig?.heroBanner;
      const bannerImg = heroBanner?.image;

      if (!bannerImg) {
        return [];
      }

      // Pick the most relevant image for this device
      const img = this.$device?.isMobile
        ? bannerImg?.mobile
        : this.$device?.isTablet
        ? bannerImg?.tablet
        : bannerImg;

      const originalUrl = img?.url;
      const imgDimensions = img?.dimensions;

      if (!originalUrl || !imgDimensions) {
        return [];
      }

      const { width, height } = this.getImageDimensions(imgDimensions, 900);

      const webpUrl = this.$img(originalUrl, {
        width: Math.round(width),
        height: Math.round(height),
        fm: "webp",
      });

      return [
        {
          rel: "preload",
          href: webpUrl,
          fetchpriority: "high",
          as: "image",
          type: "image/webp",
        },
      ];
    },
  },

  beforeDestroy() {
    this.$store.dispatch("app/CLOSE_FILTER_PANEL");
  },
};
